// Npm
import { Loader } from '@nt/dds-react';
import { useOktaAuth, SecureRoute } from '@okta/okta-react';
import React, { FC, ReactElement } from 'react';
import { Redirect, useHistory, useLocation } from 'react-router-dom';

// Local
import { useAppDispatch, useAppSelector } from '../app/hooks';
import Modal from '../components/common/Modal';
import { formatMessageHOC } from '../components/Hoc/formatMessageHOC';
import { selectAxiosData, setAxiosData } from '../pages/Home/HomeSlice';
import { FormatMessage } from '../utils/types';
import './index.css';

interface Props extends FormatMessage {}

/**
 * @param {*} {f: FormatMessage}
 * @param {*} {Component: ReactElement}
 * @return {ReactElement}
 */
const ProtectedRoute: FC<Props> = ({ f, component: Component, ...rest }: any): ReactElement => {
  const history = useHistory();
  const { authState } = useOktaAuth();
  const storeDispatch = useAppDispatch();
  const { showError, showLoader } = useAppSelector(selectAxiosData) ?? {};

  const location = useLocation().pathname.split('/');
  const currentRoute = location[location.length - 1];

  return (
    <>
      {showLoader && <Loader ariaLabel="Loading" size="lg" />}
      <SecureRoute
        {...rest}
        render={(props: any) => (authState?.isAuthenticated ? <Component {...props} /> : <Redirect to="/" />)}
      />
      <Modal
        isOpen={showError as boolean}
        size="small"
        header={{
          heading: `${f({ id: 'apiErrorModal.alert' })}`,
          iconName: ''
        }}
        footer={{
          buttonArrangement: 'fullWidth',
          primaryAction: {
            label: `${f({ id: 'apiErrorModal.btnLabel' })}`,
            onClick: () => {
              storeDispatch(setAxiosData({ showError: false }));
              if (currentRoute) {
                history.push('/');
              }
            }
          }
        }}
      >
        <div className="modal-content-wrap">
          <p className="margintop-0 roboto-font">
            {f({ id: 'apiError.message' })} <br />
            {f({ id: 'apiError.content' })}
          </p>
        </div>
      </Modal>
    </>
  );
};

ProtectedRoute.displayName = 'ProtectedRoute';
export default formatMessageHOC(ProtectedRoute);
